import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class AgentService {

    static getagent(item) {

        let api = `${API_BASE_URL}${API_PATHS.getagent}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
          if (item?.service) params.append("service", item.service);
           if (item?.search) params.append("search", item.search);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addagent(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addagent}`;
        return axiosInstance
            .post(api, data)

    }

    static editagent(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editagent}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteagent(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteagent}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default AgentService;
